import { render, staticRenderFns } from "./BaseToggleBig.vue?vue&type=template&id=96b10fb0&"
import script from "./BaseToggleBig.vue?vue&type=script&lang=ts&"
export * from "./BaseToggleBig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports